import styled from 'astroturf/react'
import _Input from "styles-Input.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/form/inputs/radio_button/styles.js?styleId=Input";
import _Body from "styles-Body.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/form/inputs/radio_button/styles.js?styleId=Body";
import _Container from "styles-Container.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/form/inputs/radio_button/styles.js?styleId=Container";

const colorStrokeDestructive = 'var(--colorStrokeDestructive, var(--coreColorRed600))'
const colorStrokeFocus = 'var(--colorStrokeFocus, var(--coreColorBlue600))'
const colorSurfaceAction = 'var(--colorSurfaceAction, var(--coreColorBlue600))'
const colorStrokeStandard = 'var(--colorStrokeStandard, var(--coreColorNeutral400))'

const size = '16px'

export const Input = /*#__PURE__*/styled('input', null, {
  displayName: "Input",
  styles: _Input,
  attrs: props => ({
    ...props,
    type: 'radio'
  })
})

export const Body = /*#__PURE__*/styled('div', null, {
  displayName: "Body",
  styles: _Body
})

export const Container = /*#__PURE__*/styled('div', null, {
  displayName: "Container",
  styles: _Container
})
